import styled, {keyframes} from "styled-components";
import {Row} from "antd";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideOut = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

export const LoginContainer = styled(Row)`
    height: 100vh;
    min-height: 100dvh;
    width: 100%;
    max-width: 100vw;
    display: flex;
    overflow: hidden;
`;

export const LoginWrapper = styled.div`
    display: flex;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100vh;
    min-height: 100dvh;
    overflow: hidden;

    > * {
        min-height: 0;
    }
`;

export const BackgroundContainer = styled.div`
    flex: 0 0 clamp(320px, 45vw, 720px);
    min-width: 0;
    height: 100%;
    display: flex;
    @media (max-width: 992px) {
        display: none;
    }
`;

export const LoginImage = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

export const LoginImageWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: ${props => (props.isActive ? 1 : 0)};
    z-index: ${props => (props.isActive ? 1 : 0)};
    animation: ${props => (props.isActive ? slideIn : slideOut)} 1.2s ease-in-out;
    transition: opacity 1.2s ease-in-out;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;

export const CompanyInformation = styled.div`
    .logo-header {
        position: absolute;
        top: 0;
        left: 0;
        padding: 20px;
    }
    .comment-container {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 20px;
        color: #ffffff;
        font-size: 18px;
        max-width: 720px;
        .comment {
            font-weight: bold;
        }
        .author {
            font-weight: thin;
        }
        @media (max-width: 1200px) {
            font-size: 16px;
            max-width: 500px;
        }
        @media (max-width: 992px) {
            font-size: 14px;
            max-width: 400px;
        }
    }
`;

export const CardContainer = styled.div`
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    padding: 0 20px;
    box-sizing: border-box;
`;

export const LoginFormScrollArea = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: #a3a3a3 #f1f1f1;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #a3a3a3;
        border-radius: 4px;
    }
`;

export const LoginFormInner = styled.div`
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 40px;
    box-sizing: border-box;
`;

export const ButtonContainer = styled.div`
    flex-direction: column;
    max-width: 100%;
`;
